import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useState } from 'react';
import Select from 'react-select';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import Switch from "react-switch"
import swal from 'sweetalert2';

const RepuestoEditModal = ({ item, selectsData, closeModal, onModalEditSubmit, columnsEnabled = [] ,action, marcaObligatorio, onSelectCategoria, marcas}) => {
    const intl = useIntl();
    const { categorias, subcategorias, unidades, tipos } = selectsData;
    const obligatorios = ConfigBusiness.get('panol.items.obligatorios')
        .split(',')
        .map((col) => col.trim());
    const [form, setForm] = useState({ ...item });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        onSelectCategoria(form.categoria)
    }, [form.categoria])

    let datoRequerido = intl.formatMessage({ id: 'validation.required', defaultMessage: 'Dato requerido' });

    const sendIfValid = (form) => {
        const reqMissing = {};

        Object.keys(form).forEach((campo) => {
            // NOTE: config panol.items.obligatorios
            if (!obligatorios.includes(campo)) {
                return;
            }

            // Si el campo no está visible en el formulario, no lo validamos
            if (columnsEnabled && columnsEnabled.hasOwnProperty(campo) && !columnsEnabled[campo]) {
                return;
            }

            // NOTE: Marca solo es obligatoria cuando marcaObligatorio es true, config inventario.marcas.obligatorio = true y tickets.presupuesto.tipo = 'detallado'
            if (campo === 'marca' && !marcaObligatorio) {
                return;
            }

            if (!form[campo]) {
                reqMissing[campo] = datoRequerido;
            }
        });

        setErrors(reqMissing);

        const missingFields = Object.keys(reqMissing);
        if (missingFields.length > 0) {
            const fieldLabels = {
                descripcion: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_descripcion', defaultMessage: 'Descripción' }),
                categoria: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_categoria', defaultMessage: 'Categoría' }),
                subcategoria: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_subCategoria', defaultMessage: 'Subcategoría' }),
                unidad: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_unidad_de_medida', defaultMessage: 'Unidad de medida' }),
                tipo: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_tipo', defaultMessage: 'Tipo' }),
                numero_parte: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_nro_de_parte', defaultMessage: 'Nro de parte' }),
                referencia: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_referencia', defaultMessage: 'Referencia' }),
                marca: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_marca', defaultMessage: 'Marca' }),
                costo: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_costo', defaultMessage: 'Costo' }),
                external_code: intl.formatMessage({ id: 'itemAbm.render.modal_edit.lavel_external_code', defaultMessage: 'Código externo' }),
            };

            const missingList = missingFields
                .map((campo) => `• ${fieldLabels[campo] || campo}`)
                .join('\n');

            swal.fire(
                intl.formatMessage({ id: 'validation.error.titulo', defaultMessage: 'Datos incompletos' }),
                intl.formatMessage(
                    {
                        id: 'validation.error.texto_con_campos',
                        defaultMessage: 'Por favor complete los siguientes campos obligatorios:\n{campos}',
                    },
                    { campos: missingList }
                ),
                'warning'
            );
            return;
        }

        let submitForm = { ...form }
        submitForm.categoria = form.categoria ? (form.categoria.value ? form.categoria.value : form.categoria) : form.categoria;
        submitForm.subcategoria = form.subcategoria ? (form.subcategoria.value ? form.subcategoria.value : form.subcategoria) : form.subcategoria;
        submitForm.unidad = form.unidad ? (form.unidad.value ? form.unidad.value : form.unidad) : form.unidad;
        submitForm.tipo = form.tipo ? (form.tipo.value ? form.tipo.value : form.tipo) : form.tipo;
        submitForm.marca = form.marca ? (form.marca.value ? form.marca.value : form.marca) : form.marca;

        onModalEditSubmit(submitForm);
    };

    useEffect(() => {
        setForm({ ...item });
    }, [item]);


    const onClose = () => {
        setErrors({});
        setForm({});
        closeModal();
    }

    const categorySelectedCheck = () => {
        if (!form.categoria) {
            setErrors({categoryEmpty: 'Debe seleccionar una categoría'});
        }
        
    }

    const handleCategoryChange = (e) => {
        setForm({ ...form, categoria: e, subcategoria: null });
        setErrors({});
        if (e) {
            onSelectCategoria(e.value)
        } else { //si se eliminó la seleccion limpio las opciones de combo de subcategoria
            onSelectCategoria(0)
        }
    }

    const handleCostoFijoChange = (e) => {
        setForm({ ...form, costo_fijo: e });
    }

    return (
        <div
            className="modal fade"
            id="editItemsModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="editItemsModalLabel"
            aria-hidden="true"
            data-backdrop="static" data-keyboard="false"
        >
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        {action === 'edit' ?
                            <h5 className="modal-title" id="editItemsModalLabel">
                                <FormattedMessage
                                    id="itemAbm.render.modal_edit.header_editar_item"
                                    defaultMessage="Editar Item"
                                />
                            </h5>
                        :  null}
                        {action === 'add' ?
                            <h5 className="modal-title" id="editItemsModalLabel">
                                <FormattedMessage
                                    id="Agregar_Item"
                                    defaultMessage="Agregar Item"
                                />
                            </h5>
                        : null}
                        <button type="button" className="close" aria-label="Close" onClick={onClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            {columnsEnabled.descripcion && (
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="editNombreItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_descripcion"
                                                defaultMessage="Descripcion del Item:"
                                            />
                                            {obligatorios.includes('descripcion') ? '*' : ''}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="descripcion"
                                            id="editNombreItem"
                                            value={form.descripcion || ''}
                                            onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
                                        />
                                        {errors.descripcion && <small className="text-danger">{errors.descripcion}</small>}
                                    </div>
                                </div>
                            )}
                                {columnsEnabled.categoria && (
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="editSubCatItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_categoria"
                                                defaultMessage="Categoria:"
                                            />
                                            {obligatorios.includes('categoria') ? '*' : ''}
                                        </label>
                                        <Select
                                            id="categoria"
                                            name="categoria"
                                            options={categorias}
                                            value={form.categoria}
                                            onChange={(e) => {handleCategoryChange(e)}}
                                        />
                                        {errors.categoria && <small className="text-danger">{errors.categoria}</small>}
                                    </div>
                                </div>
                            )}

                            {columnsEnabled.subcategoria && (
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="editSubCatItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_subCategoria"
                                                defaultMessage="SubCategoria:"
                                            />
                                            {obligatorios.includes('subcategoria') ? '*' : ''}
                                        </label>
                                        {errors.categoryEmpty && <small className="text-danger"> {errors.categoryEmpty}</small>}
                                        <Select
                                            id="subcategoria"
                                            name="subcategoria"
                                            options={subcategorias}
                                            value={form.subcategoria}
                                            onChange={(e) => setForm({ ...form, subcategoria: e })}
                                            onFocus={categorySelectedCheck}
                                        />
                                        {errors.subcategoria && <small className="text-danger">{errors.subcategoria}</small>}
                                    </div>
                                </div>
                            )}

                            {columnsEnabled.costo && (
                                <>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="editCostoItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_costo"
                                                defaultMessage="Costo:"
                                            />
                                            {obligatorios.includes('costo') ? '*' : ''}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="costo"
                                            id="editCostoItem"
                                            placeholder={intl.formatMessage({
                                                id: 'itemAbm.render.modal_edit.placeholder_costo',
                                                defaultMessage: 'Ej: 1250',
                                            })}
                                            value={form.costo || ''}
                                            onChange={(e) => setForm({ ...form, costo: e.target.value })}
                                        />
                                        {errors.costo && <small className="text-danger">{errors.costo}</small>}
                                    </div>
                                </div>

                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="costoFijo" className="col-form-label" style={{marginBottom: '5px'}}>
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_costo_editable"
                                                defaultMessage="Costo fijo:"
                                            />
                                        </label>
                                        <div className="col-md-2">
											<Switch
												onChange={(e) => {handleCostoFijoChange(e)}}
												checked={!!form.costo_fijo} // Convertir a booleano para el componente switch
												id="costoFijo"
												name="costoFijo"
												offColor="#FF4961"
												onColor="#28D094"
											/>
										</div>
                                    </div>
                                </div>
                                </>
                            )}

                            {columnsEnabled.unidad && (
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="editMedidaItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_unidad_de_medida"
                                                defaultMessage="Unidad de medida:"
                                            />
                                            {obligatorios.includes('unidad') ? '*' : ''}
                                        </label>
                                        <Select
                                            id="unidad"
                                            name="unidad"
                                            options={unidades}
                                            value={form.unidad}
                                            onChange={(e) => setForm({ ...form, unidad: e })}
                                        />
                                        {errors.unidad && <small className="text-danger">{errors.unidad}</small>}
                                    </div>
                                </div>
                            )}

                            {columnsEnabled.tipo && (
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="editTipoItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_tipo"
                                                defaultMessage="Tipo:"
                                            />
                                            {obligatorios.includes('tipo') ? '*' : ''}
                                        </label>
                                        <Select
                                            id="tipo"
                                            name="tipo"
                                            valueKey="value"
                                            labelKey="label"
                                            options={tipos}
                                            value={form.tipo}
                                            onChange={(e) => setForm({ ...form, tipo: e })}
                                        />
                                        {errors.tipo && <small className="text-danger">{errors.tipo}</small>}
                                    </div>
                                </div>
                            )}

                            {columnsEnabled.numero_parte && (
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="editNroParteItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_nro_de_parte"
                                                defaultMessage="Nro de parte:"
                                            />
                                            {obligatorios.includes('numero_parte') ? '*' : ''}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="numeroDeParte"
                                            id="editNroParteItem"
                                            placeholder={intl.formatMessage({
                                                id: 'itemAbm.render.modal_edit.placeholder_nro_de_parte',
                                                defaultMessage: 'Ej: 000153654',
                                            })}
                                            value={form.numero_parte || ''}
                                            onChange={(e) => setForm({ ...form, numero_parte: e.target.value })}
                                        />
                                        {errors.numero_parte && <small className="text-danger">{errors.numero_parte}</small>}
                                    </div>
                                </div>
                            )}
                            {columnsEnabled.referencia && (
                                <div className="col-md-8">
                                    <div className="form-group">
                                        <label htmlFor="referenciaItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_referencia"
                                                defaultMessage="Referencia:"
                                            />
                                            {obligatorios.includes('referencia') ? '*' : ''}
                                        </label>
                                        <textarea
                                            className="form-control"
                                            name="referencia"
                                            id="editReferenciaItem"
                                            placeholder={intl.formatMessage({
                                                id: 'itemAbm.render.modal_edit.placeholder_referencia',
                                                defaultMessage: 'Ej: alguna referencia de algo',
                                            })}
                                            value={form.referencia || ''}
                                            onChange={(e) => setForm({ ...form, referencia: e.target.value })}
                                        />
                                        {errors.referencia && <small className="text-danger">{errors.referencia}</small>}
                                    </div>
                                </div>
                            )}

                            {columnsEnabled.marca && marcaObligatorio ? (
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="editMarcaItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_marca"
                                                defaultMessage="Marca:"
                                            />
                                            {obligatorios.includes('marca') ? '*' : ''}
                                        </label>
                                        <Select
                                            id="marca"
                                            name="marca"
                                            options={marcas}
                                            value={form.marca}
                                            onChange={(e) => setForm({ ...form, marca: e })}
                                        />
                                        {errors.marca && <small className="text-danger"> {errors.marca}</small>}
                                    </div>
                                </div>
                            ) : ''}
                            {columnsEnabled.external_code && (
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="editExternalCodeItem" className="col-form-label">
                                            <FormattedMessage
                                                id="itemAbm.render.modal_edit.lavel_external_code"
                                                defaultMessage="External Code:"
                                            />
                                            {obligatorios.includes('external_code') ? '*' : ''}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="externalCode"
                                            id="editExternalCodeItem"
                                            placeholder={intl.formatMessage({
                                                id: 'itemAbm.render.modal_edit.placeholder_external_code',
                                                defaultMessage: 'External Code',
                                            })}
                                            value={form.external_code || ''}
                                            onChange={(e) => setForm({ ...form, external_code: e.target.value })}
                                        />
                                        {errors.external_code && <small className="text-danger">{errors.external_code}</small>}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            <FormattedMessage
                                id="itemAbm.render.modal_edit.finish_button.cancelar"
                                defaultMessage="Cancelar"
                            />
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => sendIfValid(form)}
                        >
                            <FormattedMessage
                                id="itemAbm.render.modal_edit.finish_button.guardar_datos"
                                defaultMessage="Guardar datos"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default RepuestoEditModal;
